import React, { useEffect, useState } from "react";
import { MapContainer, TileLayer, GeoJSON, LayersControl } from "react-leaflet";
import L from 'leaflet';
import "leaflet/dist/leaflet.css";
import "./Overview.css";
import MapInfoBox from "./MapInfoBox/MapInfoBox";
import { MapHomeControl, MapLegendControl } from "../../../common/MapControls/MapControls";

const Overview = () => {
    const [boundaryData, setBoundaryData] = useState(null);
    const URLTILEMAP_OSM = "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png";

    const [MajorRiver, setMajorRiver] = useState(null);
    const [catchmentData, setCatchmentData] = useState(null);
    const [dischargePointsData, setDischargePointsData] = useState(null);

    useEffect(() => {
        fetch("/DATA/OSMbased_adm2_boundary.json")
            .then((response) => response.json())
            .then((data) => setBoundaryData(data))
            .catch((error) => console.error("Error loading boundary data:", error));
    }, []);

    useEffect(() => {
        fetch("/DATA/Flood/Rivers.json")
            .then((response) => response.json())
            .then((data) => setMajorRiver(data))
            .catch((error) => console.error("Error loading rivers data:", error));
    }, []);

    useEffect(() => {
        fetch("/DATA/Flood/Catchments.json")
            .then((response) => response.json())
            .then((data) => setCatchmentData(data))
            .catch((error) => console.error("Error loading catchments data:", error));
    }, []);

    useEffect(() => {
        fetch("/DATA/Flood/DischargePoints.json")
            .then((response) => response.json())
            .then((data) => setDischargePointsData(data))
            .catch((error) => console.error("Error loading discharge points:", error));
    }, []);

    const [selCatchment, setselCatchment] = useState(null);
    const CatchmentFeature = (feature, layer) => {
        layer.on({
            mouseover: () => {
                setselCatchment(`<div><strong>Catchment</strong><p>Name :  ${feature.properties.Catchment_}</p></div>`);
            },
            mouseout: () => {
                setselCatchment(null);
            }
        });
    };

    const pointStyle = {
        color: 'black',
        radius: 6,
    };

    const [dischargeFet, setDischargeFet] = useState(null);
    const DischargeFeat = (feature, layer) => {
        layer.on({
            mouseover: () => {
                setDischargeFet(`<div><strong>Discharge Point</strong><p>Name:  ${feature.properties.Name}</p></div>`);
            },
            mouseout: () => {
                setDischargeFet(null);
            }
        });
    };

    const Legend = () => (
        <MapLegendControl
            sections={[{
                items: [
                    { label: "River Network", color: "blue" },
                    { label: "Catchments", color: "#ff5733" },
                    { label: "Discharge Points", color: "black" },
                ],
            }]}
        />
    );

    const [formData, setFormData] = useState({
        basinName: "No selection",
        satationName: "No selection",
    });

    const [, setSubmittedData] = useState(null);

    const handleChange = (event) => {
        setFormData({
            ...formData,
            [event.target.name]: event.target.value,
        });
    };

    const handleSubmit = () => {
        setSubmittedData(formData);
    };

    const isFormIncomplete = Object.values(formData).includes("No selection");

    return (
        <div className="map-container-flood-overview">
            <MapContainer
                center={[-8.6450, 125.6877]}
                attributionControl={false}
                zoom={10}
                style={{ width: "100%", height: "650px" }}
            >
              <MapHomeControl />
                <TileLayer url={URLTILEMAP_OSM} />
                
                <LayersControl position="topright">
                    <LayersControl.Overlay name="Timor-Leste" checked>
                        {boundaryData && (
                            <GeoJSON
                                data={boundaryData}
                                style={{
                                    color: "#000000",
                                    weight: 0.8,
                                    opacity: 0.8,
                                    fillOpacity: 0,
                                }}
                            />
                        )}
                    </LayersControl.Overlay>
                    <LayersControl.Overlay name="River Network" checked>
                        {MajorRiver && (
                            <GeoJSON
                                data={MajorRiver}
                                style={{
                                    color: "blue",
                                    weight: 1,
                                    opacity: 0.8,
                                    fillOpacity: 0,
                                }}
                            />
                        )}
                    </LayersControl.Overlay>
                    <LayersControl.Overlay name="Catchments">
                        {catchmentData && (
                            <GeoJSON
                                data={catchmentData}
                                style={{
                                    color: "#ff5733",
                                    weight: 2,
                                    opacity: 0.8,
                                    fillOpacity: 0.2,
                                }}
                                onEachFeature={CatchmentFeature}
                            />
                        )}
                    </LayersControl.Overlay>
                    <LayersControl.Overlay name="Discharge Points">
                        {dischargePointsData && (
                            <GeoJSON
                                data={dischargePointsData}
                                pointToLayer={(feature, latlng) => L.circleMarker(latlng, pointStyle)}
                                onEachFeature={DischargeFeat}
                            />
                        )}
                    </LayersControl.Overlay>
                </LayersControl>
                <Legend position="bottomright" />

                <div className="map-dropdown-overlay">
                    <div className="dropdown-container-map">
                        <label>Select Basin</label>
                        <select name="basinName" value={formData.basinName} onChange={handleChange}>
                            <option value="No selection">No selection</option>
                            <option>Comoro</option>
                            <option>Comoro US 1</option>
                            <option>Comoro US 2</option>
                            <option>Maloa</option>
                            <option>River 3</option>
                            <option>River 4</option>
                            <option>River 5</option>
                        </select>
                    </div>
                    <div className="dropdown-container-map">
                        <label>Select Station</label>
                        <select name="satationName" value={formData.satationName} onChange={handleChange}>
                            <option value="No selection">No selection</option>
                            <option>Comoro Station</option>
                            <option>Comoro Upstream 1</option>
                            <option>Comoro Upstream 2</option>
                            <option>Maloa Station</option>
                            <option>River 3 Station</option>
                            <option>River 4 Station</option>
                            <option>River 5 Station</option>
                        </select>
                    </div>
                    <button className="submit-button-flood-map" onClick={handleSubmit} disabled={isFormIncomplete}>
                        Submit
                    </button>
                </div>
                <MapInfoBox />
            </MapContainer>

            {selCatchment && (
                <div className="hover-box" dangerouslySetInnerHTML={{ __html: selCatchment }} />
            )}
            {dischargeFet && (
                <div className="hover-box" dangerouslySetInnerHTML={{ __html: dischargeFet }} />
            )}
        </div>
    );
};

export default Overview;
